// extracted by mini-css-extract-plugin
module.exports = {"container":"_1IanH3JtoS1t3JbmkqqCFf","title":"_2lM31GEQm6exS7ho25lMwA","message":"jzfEshHM3Bth_yUDK13tM"};